import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","height":"100vh"} }
const _hoisted_2 = {
  id: "primaryContent",
  class: "other_content",
  style: {"height":"0","flex":"1","overflow":"auto"}
}

import Chead from '@/components/Chead.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Chead),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})